import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, FieldArray, formValueSelector, change } from "redux-form";
import { Link, browserHistory } from "react-router";
import { toastr } from "react-redux-toastr";

import TextField from "../../components/Fields/TextField";
import SelectField from "../../components/Fields/SelectField";
import TextareaField from "../../components/Fields/TextareaField";
import TextDatePickerField from "../../components/Fields/TextDatePickerField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import FieldValidation from "../../components/Validation/FieldValidation";
import MaskDate from "../../components/Util/MaskDate";

import { SURVEY_EDIT_LOAD, SURVEY_EDIT_UNLOAD, LOGOUT } from "../../actions/Constants";
import api from "../../api/apiUtil";

import Title from "../../components/Layout/Title";
import { SubmissionError } from "redux-form";
import _ from "lodash";

const questionTypes = [
  { id: "text", name: "Texto Aberto" },
  { id: "choice", name: "Múltipla Escolha" },
  { id: "rating", name: "Avaliação (5 Estrelas)" },
  { id: "likert", name: "Escala Likert (Matricial)" },
];

class SurveyEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      questions: [],
    };
  }

  componentWillMount() {
    if (this.props.params?.slug && this.props.params.slug !== "new") {
      this.props.onLoad(Promise.resolve(api.Survey.get(this.props.params.slug)));
    } else {
      this.props.onLoad();

      // Check if there's a copied survey in sessionStorage
      const copiedSurvey = sessionStorage.getItem("copiedSurvey");
      if (copiedSurvey) {
        try {
          const surveyData = JSON.parse(copiedSurvey);
          // Set the initial values with the copied survey data
          this.props.dispatch(change("SurveyEditForm", "titulo", ""));
          this.props.dispatch(change("SurveyEditForm", "dataInicio", MaskDate.TO_BR(new Date())));
          this.props.dispatch(change("SurveyEditForm", "dataFim", surveyData.dataFim ? MaskDate.TO_BR(surveyData.dataFim) : ""));
          this.props.dispatch(change("SurveyEditForm", "habilitada", "N")); // Default to not enabled
          this.props.dispatch(change("SurveyEditForm", "descricao", surveyData.descricao || ""));
          this.props.dispatch(
            change(
              "SurveyEditForm",
              "perguntas",
              (surveyData.perguntas || []).map((p) => ({
                ...p,
                obrigatoria: p.obrigatoria ? "S" : "N",
                opcoes: p.configuracao?.opcoes?.map((o) => o.texto) || [],
                opcoesLikert: p.configuracao?.opcoesLikert?.map((o) => o.texto) || ["", "", "", "", ""],
                itensLikert: p.configuracao?.itensLikert || [],
              }))
            )
          );

          // Remove the copied survey from sessionStorage
          sessionStorage.removeItem("copiedSurvey");
        } catch (e) {
          console.error("Error parsing copied survey data", e);
        }
      } else {
        // Default initialization
        this.props.dispatch(change("SurveyEditForm", "dataInicio", MaskDate.TO_BR(new Date())));
      }
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  formSubmit(values) {
    var props = this.props;

    var survey = {
      titulo: values.titulo,
      dataInicio: MaskDate.TO_DATABASE(values.dataInicio),
      dataFim: MaskDate.TO_DATABASE(values.dataFim),
      habilitada: values.habilitada === "S",
      descricao: values.descricao,
    };

    // Se a pesquisa já tem respostas, mantemos as perguntas originais para não perder a estrutura
    if (this.props.survey && this.props.survey.respostaCount > 0) {
      // Quando a pesquisa tem respostas, apenas atualizamos os campos permitidos (título, status, datas)
      // As perguntas originais são mantidas no backend sem alterações
      survey.perguntas = this.props.survey.perguntas; // Mantém as perguntas originais
      if (this.props.survey && this.props.survey.id) {
        survey.id = this.props.survey.id;
        Promise.resolve(api.Survey.update(survey))
          .then((ret) => {
            toastr.success("Sucesso", "Pesquisa alterada");
            browserHistory.push("/alias/surveys");
          })
          .catch(function (resp) {
            if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.error("Erro", resp.response && resp.response.body ? resp.response.body.message : "Ocorreu um erro ao realizar a operação!");
            }
          });
      }
    } else {
      // Padroniza as perguntas para ter uma estrutura consistente no backend
      const perguntasPadronizadas = (values.perguntas || []).map((pergunta, index) => {
        const perguntaPadrao = {
          id: index + 1,
          tipo: pergunta.tipo || "text",
          titulo: pergunta.titulo || "",
          obrigatoria: pergunta.obrigatoria === "S" || pergunta.obrigatoria === true,
          configuracao: {},
        };

        // Configuração específica por tipo de pergunta
        switch (pergunta.tipo) {
          case "choice":
            perguntaPadrao.configuracao = {
              opcoes: (pergunta.opcoes || [])
                .filter((opcao) => opcao && opcao.trim() !== "")
                .map((opcao, opcaoIndex) => ({
                  id: opcaoIndex + 1,
                  texto: opcao,
                })),
            };
            break;
          case "likert":
            perguntaPadrao.configuracao = {
              opcoesLikert: (pergunta.opcoesLikert || ["", "", "", "", ""]).map((opcao, opcaoIndex) => ({
                id: opcaoIndex + 1,
                texto: opcao,
              })),
              itensLikert: (pergunta.itensLikert || []).map((item, itemIndex) => ({
                id: itemIndex + 1,
                titulo: item.titulo || "",
              })),
            };
            break;
          case "rating":
            perguntaPadrao.configuracao = {
              escala: 5, // Padrão de 5 estrelas
            };
            break;
          default:
            perguntaPadrao.configuracao = {};
        }

        return perguntaPadrao;
      });

      survey.perguntas = perguntasPadronizadas;

      if (this.props.survey && this.props.survey.id) {
        survey.id = this.props.survey.id;
        Promise.resolve(api.Survey.update(survey))
          .then((ret) => {
            toastr.success("Sucesso", "Pesquisa alterada");
            browserHistory.push("/alias/surveys");
          })
          .catch(function (resp) {
            if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.error("Erro", resp.response && resp.response.body ? resp.response.body.message : "Ocorreu um erro ao realizar a operação!");
            }
          });
      } else {
        Promise.resolve(api.Survey.create(survey))
          .then((ret) => {
            toastr.success("Sucesso", "Pesquisa cadastrada");
            browserHistory.push("/alias/surveys");
          })
          .catch(function (resp) {
            if (resp === "Unauthorized" || resp === "jwt expired") {
              api.Auth.logout();
              props.onLogout();
            } else {
              toastr.error("Erro", resp.response && resp.response.body ? resp.response.body.message : "Ocorreu um erro ao realizar a operação!");
            }
          });
      }
    }
  }

  renderQuestions = ({ fields, meta: { error } }) => (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="panel-tools">
            <button
              type="button"
              className="btn btn-sm btn-info"
              onClick={() =>
                fields.push({
                  tipo: "text",
                  titulo: "",
                  obrigatoria: "S",
                  opcoes: [],
                  itensLikert: [],
                  opcoesLikert: ["", "", "", "", ""], // 5 opções vazias para customização
                })
              }
            >
              <i className="fas fa-plus" /> Adicionar Pergunta
            </button>
          </div>
        </div>
      </div>

      {fields.map((question, index) => (
        <div key={index} className="hpanel">
          <div className="panel-heading">
            <div className="panel-tools">
              <button type="button" className="btn btn-xs btn-danger" onClick={() => fields.remove(index)}>
                <i className="fas fa-trash" /> Remover
              </button>
            </div>
            Pergunta {index + 1}
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-7">
                <Field name={`${question}.titulo`} label="Título da Pergunta" required={true} component={TextField} type="text" validate={[FieldValidation.required]} />
              </div>
              <div className="col-md-3">
                <Field
                  name={`${question}.tipo`}
                  label="Tipo de Pergunta"
                  required={true}
                  data={questionTypes}
                  component={SelectField}
                  type="text"
                  valueField="id"
                  textField="name"
                  validate={[FieldValidation.required]}
                />
              </div>
              <div className="col-md-2">
                <Field
                  name={`${question}.obrigatoria`}
                  label="Obrigatória"
                  data={[
                    { id: "S", name: "Sim" },
                    { id: "N", name: "Não" },
                  ]}
                  component={SelectField}
                  type="text"
                  valueField="id"
                  textField="name"
                />
              </div>
            </div>

            {this.renderQuestionOptions(question, index)}
          </div>
        </div>
      ))}
    </div>
  );

  renderQuestionOptions = (question, questionIndex) => {
    const questionType = this.props.formValues && this.props.formValues[questionIndex]?.tipo;

    if (questionType === "choice") {
      return <FieldArray name={`${question}.opcoes`} component={this.renderChoiceOptions} />;
    }

    if (questionType === "likert") {
      return (
        <div>
          {/* Configuração das 5 opções da escala Likert */}
          <div className="row">
            <div className="col-md-12">
              <h5>Configurar Opções da Escala Likert:</h5>
            </div>
          </div>
          <div className="row">
            {[0, 1, 2, 3, 4].map((opcaoIndex) => (
              <div key={opcaoIndex} className="col-md-2">
                <Field
                  name={`${question}.opcoesLikert[${opcaoIndex}]`}
                  label={`Opção ${opcaoIndex + 1}`}
                  component={TextField}
                  type="text"
                  placeholder={`Ex: ${
                    opcaoIndex === 0 ? "Muito Insatisfeito" : opcaoIndex === 1 ? "Insatisfeito" : opcaoIndex === 2 ? "Neutro" : opcaoIndex === 3 ? "Satisfeito" : "Muito Satisfeito"
                  }`}
                  validate={[FieldValidation.required, FieldValidation.nospace]}
                  required={true}
                />
              </div>
            ))}
          </div>

          {/* Itens da matriz Likert */}
          <div className="row">
            <div className="col-md-12">
              <h5>Itens da Matriz:</h5>
              <FieldArray name={`${question}.itensLikert`} component={this.renderLikertItems} />
            </div>
          </div>
        </div>
      );
    }

    if (questionType === "rating") {
      return (
        <div className="row">
          <div className="col-md-12">
            <label>Avaliação por Estrelas (1 a 5)</label>
            <div className="well">
              <i className="fas fa-star text-warning"></i>
              <i className="fas fa-star text-warning"></i>
              <i className="fas fa-star text-warning"></i>
              <i className="fas fa-star text-warning"></i>
              <i className="fas fa-star text-warning"></i>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  renderLikertItems = ({ fields, meta: { error } }) => (
    <div>
      <div className="row">
        <div className="col-md-12">
          <button type="button" className="btn btn-xs btn-info pull-right" onClick={() => fields.push({ titulo: "" })}>
            <i className="fas fa-plus" /> Adicionar Item
          </button>
        </div>
      </div>

      {fields.map((item, index) => (
        <div key={index} className="panel panel-default" style={{ marginTop: "10px" }}>
          <div className="panel-heading" style={{ marginBottom: "5px" }}>
            Item {index + 1}
            <button type="button" className="btn btn-xs btn-danger pull-right" onClick={() => fields.remove(index)} style={{ marginLeft: "10px" }}>
              <i className="fas fa-trash" />
            </button>
          </div>
          <div className="panel-body">
            <div className="row align-items-center">
              <div className="col-md-12">
                <Field
                  name={`${item}.titulo`}
                  label="Título do Item"
                  component={TextField}
                  type="text"
                  placeholder={`Ex: Qualidade do atendimento`}
                  validate={[FieldValidation.required, FieldValidation.nospace]}
                  required={true}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
  renderChoiceOptions = ({ fields, meta: { error } }) => (
    <div>
      <div className="row">
        <div className="col-md-12">
          <label>Opções de Escolha:</label>
          <button type="button" className="btn btn-xs btn-info pull-right" onClick={() => fields.push("")}>
            <i className="fas fa-plus" /> Adicionar Opção
          </button>
        </div>
      </div>

      {fields.map((option, index) => (
        <div key={index} className="row align-items-center" style={{ marginBottom: "10px" }}>
          <div className="col-md-10">
            <Field name={option} component={TextField} type="text" validate={[FieldValidation.required, FieldValidation.nospace]} required={true} placeholder={`Opção ${index + 1}`} />
          </div>
          <div className="col-md-2">
            <button type="button" className="btn btn-xs btn-danger" onClick={() => fields.remove(index)}>
              <i className="fas fa-trash" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );

  render() {
    // if (!this.props.editLoad) {
    //   return null;
    // }

    const { handleSubmit } = this.props;

    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Configuração de Pesquisas de Satisfação" />

        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    <Link className="btn btn-xs btn-default" onClick={browserHistory.goBack}>
                      <i className="fas fa-arrow-left"></i> Voltar
                    </Link>
                  </div>
                  {this.props.survey?.id ? "Editar Pesquisa" : "Nova Pesquisa"}
                </div>

                <div className="panel-body">
                  <form
                    className="form-horizontal"
                    noValidate
                    onSubmit={handleSubmit((values) => {
                      return new Promise((resolve, reject) => {
                        const errors = validate(values);
                        if (errors && !_.isEmpty(errors)) {
                          reject(new SubmissionError(errors));
                        } else {
                          this.formSubmit(values);
                          resolve();
                        }
                      });
                    })}
                  >
                    {/* Informações Básicas */}
                    <div className="row">
                      <div className="col-md-6">
                        <Field name="titulo" label="Título da Pesquisa" required={true} component={TextField} type="text" validate={[FieldValidation.required, FieldValidation.nospace]} />
                      </div>
                      <div className="col-md-2">
                        <Field
                          name="habilitada"
                          label="Status"
                          blank={true}
                          required={true}
                          data={[
                            { id: "S", name: "Habilitada" },
                            { id: "N", name: "Não Habilitada" },
                          ]}
                          component={SelectField}
                          type="text"
                          valueField="id"
                          textField="name"
                          validate={[FieldValidation.required]}
                        />
                      </div>
                      <div className="col-md-2">
                        <Field
                          name="dataInicio"
                          label="Data de Início"
                          type="text"
                          required={true}
                          placeholder="00/00/0000"
                          component={TextDatePickerField}
                          validate={[FieldValidation.date, FieldValidation.required]}
                          normalize={FieldNormalize.DATE}
                        />
                      </div>
                      <div className="col-md-2">
                        <Field
                          name="dataFim"
                          label="Data de Fim"
                          type="text"
                          placeholder="00/00/0000"
                          component={TextDatePickerField}
                          validate={[FieldValidation.date]}
                          normalize={FieldNormalize.DATE}
                        />
                      </div>
                    </div>

                    <hr />

                    {/* Seção de Perguntas - Exibir apenas se a pesquisa for nova ou não tiver respostas */}
                    {!(this.props.survey && this.props.survey.respostaCount > 0) && (
                      <div>
                        {/* Seção de Perguntas */}
                        <div className="row">
                          <div className="col-md-12">
                            <h4>Perguntas da Pesquisa</h4>
                            <FieldArray name="perguntas" component={this.renderQuestions} />
                          </div>
                        </div>

                        {this.props.formValues && this.props.formValues.length > 0 && (
                          <div className="row">
                            <div className="col-md-12">
                              <div className="text-right">
                                <Link className="btn btn-default" to="/alias/surveys">
                                  Cancelar
                                </Link>
                                <button className="btn btn-info" type="submit">
                                  Salvar Pesquisa
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Mostrar mensagem e botão de salvar quando houver respostas */}
                    {this.props.survey && this.props.survey.respostaCount > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="alert alert-warning">
                            <i className="fas fa-exclamation-triangle"></i> Esta pesquisa já possui respostas registradas. Apenas o título, status e datas podem ser editados.
                          </div>
                          <div className="text-right">
                            <Link className="btn btn-default" to="/alias/surveys">
                              Cancelar
                            </Link>
                            <button className="btn btn-info" type="submit">
                              Salvar Alterações
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (!values.titulo || values.titulo.trim().length === 0) {
    errors.titulo = "Título é obrigatório";
  }

  if (!values.habilitada) {
    errors.habilitada = "Status é obrigatório";
  }

  if (!values.dataInicio) {
    errors.dataInicio = "Data de início é obrigatória";
  }

  if (values.dataFim && values.dataInicio) {
    if (MaskDate.IS_BEFORE(values.dataFim, values.dataInicio)) {
      errors.dataFim = "Data de fim deve ser posterior à data de início";
    }
  }

  // Validação das perguntas
  if (values.perguntas && values.perguntas.length > 0) {
    const perguntasErrors = [];
    values.perguntas.forEach((pergunta, index) => {
      const perguntaErrors = {};

      // Validar opções para perguntas de múltipla escolha
      if (pergunta.tipo === "choice") {
        if (!pergunta.opcoes || pergunta.opcoes.length < 2) {
          toastr.warning("Atenção", "Perguntas de múltipla escolha devem ter pelo menos 2 opções.");
          perguntaErrors._error = "Perguntas de múltipla escolha devem ter pelo menos 2 opções.";
        }
      }

      // Validar perguntas do tipo Likert
      if (pergunta.tipo === "likert") {
        if (!pergunta.itensLikert || pergunta.itensLikert.length === 0) {
          toastr.warning("Atenção", "Perguntas do tipo Likert devem ter pelo menos 1 item na matriz.");
          perguntaErrors._error = "Perguntas do tipo Likert devem ter pelo menos 1 item na matriz.";
        }
      }

      if (Object.keys(perguntaErrors).length > 0) {
        perguntasErrors[index] = perguntaErrors;
      }
    });

    if (perguntasErrors.length > 0) {
      errors.perguntas = perguntasErrors;
    }
  }

  return errors;
}

const mapDispatchToProps = (dispatch) => ({
  onLoad: (payload) => dispatch({ type: SURVEY_EDIT_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: SURVEY_EDIT_UNLOAD, payload }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const selector = formValueSelector("SurveyEditForm");
const mapStateToProps = (state) => {
  const { survey } = state.surveyEdit;
  let initialValues = null;

  if (survey) {
    initialValues = {
      ...survey,
      dataInicio: MaskDate.TO_BR(survey.dataInicio),
      dataFim: MaskDate.TO_BR(survey.dataFim),
      habilitada: survey.habilitada ? "S" : "N",
      perguntas: (survey.perguntas || []).map((p) => ({
        ...p,
        obrigatoria: p.obrigatoria ? "S" : "N",
        opcoes: p.configuracao?.opcoes?.map((o) => o.texto) || [],
        opcoesLikert: p.configuracao?.opcoesLikert?.map((o) => o.texto) || ["", "", "", "", ""],
        itensLikert: p.configuracao?.itensLikert || [],
      })),
    };
  }

  return {
    ...state.surveyEdit,
    formValues: selector(state, "perguntas"),
    initialValues,
    currentUser: state.common.currentUser,
  };
};

const form = reduxForm({
  form: "SurveyEditForm",
  //enableReinitialize: true,
});

export default connect(mapStateToProps, mapDispatchToProps)(form(SurveyEdit));
